import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Strengths.css';

const ICONS = [
  <path key="sourcing" d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />,
  <path key="market" d="m3 11 9-8 9 8M5 10v10h14V10" />,
  <path key="partnership" d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM16 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 20c0-3 3-5 6-5s6 2 6 5M10 20c0-3 3-5 6-5s6 2 6 5" />,
];

export default function Strengths() {
  const { t } = useLanguage();

  return (
    <section className="section section--alt strengths">
      <div className="container">
        <div className="section-head section-head--center">
          <h2 className="section-title">{t.strengths.title}</h2>
        </div>
        <div className="strengths__grid">
          {t.strengths.items.map((item, i) => (
            <div className="strength-card" key={item.title}>
              <span className="strength-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {ICONS[i]}
                </svg>
              </span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
